import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5040Class } from '../../CSPClass/CSP5040/csp5040-class';
import { environment } from '../../../../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Csp5040Service {
  baseUrl: string=  environment.baseUrlCsp + 'CSP5040/';
  constructor(private http:HttpClient) { }
   Outstanding(Csp5040Class:Csp5040Class):Observable<any>
   {
      return this.http.post<any>(this.baseUrl+'Outstanding',Csp5040Class);
  }
}
